import { useCallback } from 'react'
import { useMutation } from 'react-apollo'

import { useRestaurant } from '../components/RestaurantProvider/RestaurantProvider'
import { useFulfillment } from '../components/FulfillmentProvider/FulfillmentProvider'
import { useOutpostRestaurant } from '../components/OutpostProvider/OutpostProvider'

import { SET_ACTIVE_MENU } from './MenuSelector.graphql'
import { MENUS } from '../apollo/menu/menus.graphql'

export const useMenuSelection = (opts = {}) => {
  const { shortUrl } = useRestaurant()
  const { fulfillmentTime } = useFulfillment()
  const { outpostDeliveryDateTime } = useOutpostRestaurant()

  const dateTime = outpostDeliveryDateTime || fulfillmentTime || undefined

  const variables = { input: { shortUrl, dateTime } }
  const [setActiveMenu] = useMutation(SET_ACTIVE_MENU, {
    update: (store, { data: { setActiveMenu: { id } } }) => {
      // Need to force update the cache for MENUS query
      // with the current selected menu
      const data = store.readQuery({ query: MENUS, variables })
      const menus = data.menusV3.menus.map(menu => ({
        ...menu,
        isActive: menu.id === id
      }))
      store.writeQuery({ query: MENUS, data: { menusV3: { menus: [...menus], __typename: 'MenusResponse' } }, variables })
    },
    ...opts
  })

  return useCallback(
    id => {
      setActiveMenu({ variables: { id, shortUrl, dateTime } })
    },
    [dateTime, setActiveMenu, shortUrl]
  )
}
